<template>
    <div>
        <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">
            <div class="content">
                <section class="section--sidebar-user">

                    <section class="section--content-sidebar section--content-sidebar-full-height">
                        <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data"
                            class="workflow-tabs">
                            <div class="tab-content">
                                <input type="hidden" name="_token" :value="csrf">
                                <input v-if="this.editing" type="hidden" name="_method" value="PUT">

                                <div class="row mb-3">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{ __('forms.Question.title') }}</label>
                                            <input type="text" class="form-control rounded" name="questionBase[name]"
                                                :value="this.name">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{ __('forms.Question.description') }}</label>
                                            <input type="text" class="form-control rounded"
                                                name="questionBase[description]" :value="this.description">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{ __('forms.Question.sorting') }}</label>
                                            <input type="number" class="form-control rounded"
                                                name="questionBase[sorting]" :value="this.sorting">
                                        </div>
                                    </div>
                                </div>

                                <tabs>
                                    <tab
                                        :name="__('forms.EvaluationChart.questions.questions_setting.question43.organizational_units')">
                                        <div class="row mt-3">
                                            <div class="col-4">

                                                <label>{{
                                                    __('forms.EvaluationChart.questions.questions_setting.question43.col_1.title')
                                                }}
                                                </label>
                                                <hr>
                                                <div class="ou-filter-card">
                                                    <div class='form-group mb-2'>
                                                        <input v-model="filter_bar" type="text" class="form-control rounded"
                                                            :placeholder="__('misc.search')" @input="onSearchBarOUInput">
                                                    </div>

                                                    <label class="ou-filter-card__label">
                                                        {{
                                                            __('forms.EvaluationChart.questions.questions_setting.question43.col_1.uo_typology')
                                                        }}
                                                    </label>

                                                    <div v-for='out in ou_types_for_filters' :key="out.id"
                                                        class="form-check">
                                                        <input :id="'outype_' + out.id" class="form-check-input"
                                                            type="radio" v-model.number="out_selected"
                                                            :value="Number(out.id)"
                                                            @click="chooseOrganizationalUnitType(Number(out.id))">
                                                        <label class="form-check-label" :for="'outype_' + out.id">{{
                                                            out.name }}</label>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="col-4">
                                                <label>
                                                    {{
                                                        __('forms.EvaluationChart.questions.questions_setting.question43.col_2.title')
                                                    }}
                                                </label>
                                                <hr>

                                                <div class="ou-type-list">
                                                    <div v-for="out in out_with_ou_list" :key="out.id"
                                                        class="ou-type-card">
                                                        <div class="ou-type-card__title">{{ out.name }}</div>
                                                        <label v-for="ou in out.ous" :key="ou.id"
                                                            class="ou-checkbox-row">
                                                            <input type="checkbox" class="mr-2"
                                                                :checked="isOuSelected(ou.id)"
                                                                @change="toggleOuAvailability(ou.id, $event.target.checked)">
                                                            <span>{{ ou.name }}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-4">
                                                <label>
                                                    {{
                                                        __('forms.EvaluationChart.questions.questions_setting.question43.col_3.title')
                                                    }}
                                                </label>
                                                <hr>

                                                <div class="ou-type-list">
                                                    <div v-for="out in out_with_ou_selected" :key="out.id"
                                                        class="ou-type-card ou-type-card--selected">
                                                        <div class="ou-type-card__title">{{ out.name }}</div>
                                                        <label v-for="ou in out.ous" :key="ou.id"
                                                            class="ou-checkbox-row">
                                                            <input type="checkbox" class="mr-2"
                                                                :checked="isOuSelected(ou.id)"
                                                                :key="out.id"
                                                                name='questionSettings[ou_available][]' :value="ou.id"
                                                                @change="toggleOuAvailability(ou.id, $event.target.checked)">
                                                            <span>{{ ou.name }}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </tab>
                                </tabs>


                                <div class="row">

                                    <div class="col-12 mt-3 text-right" v-if="can_write">
                                        <button class="btn btn-next" type="submit">{{ __('misc.save') }}</button>
                                    </div>
                                </div>

                            </div>
                        </form>
                    </section>
                </section>
            </div>
        </vs-popup>
    </div>
</template>

<script>
export default {

    props: {
        can_write: {
            type: Boolean,
            required: true,
        }
    },
    data() {
        return {
            //default
            title: '',
            active: false,
            action: "",
            name: "",
            description: "",
            sorting: -1,
            editing: true,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            //question specific
            ou_all: [],
            out_with_ou_list: [], //Used for 2column
            out_with_ou_selected: [], //Used for 3column

            ou_available_ids: [],
            ou_types_for_filters: [],
            //filters
            filter_bar: "",
            out_selected: 0, //0 is stand for all, 
            searchOuDebounceTimer: null,

        }
    },
    mounted() {
        this.getAllOuGroupedByType();
        this.chooseOrganizationalUnitType(0); //Default to all organizational unit types on mount
    },
    computed: {

    },
    methods: {
        //Deferr\ed execution of the search function to avoid triggering it on every keystroke
        onSearchBarOUInput(event) {
            const value = event.target.value;

            if (this.searchOuDebounceTimer) {
                clearTimeout(this.searchOuDebounceTimer);
            }

            this.searchOuDebounceTimer = setTimeout(() => {
                this.getFilteredOrganizationalUnits(this.out_selected, value);
            }, 400);
        },

        chooseOrganizationalUnitType(id) {
            this.out_selected = Number(id);
            this.filter_bar = '';
            this.getFilteredOrganizationalUnits(this.out_selected, this.filter_bar);
        },


        getFilteredOrganizationalUnits(out_selected, filter_bar) {
            const normalizedTypeId = out_selected === null ? null : Number(out_selected);
            const normalizedSearch = (filter_bar || '').trim().toLowerCase();

            const filteredAvailableOuts = this.ou_all
                .map(out => {
                    const typeMatches = normalizedTypeId === null || normalizedTypeId === -1 || normalizedTypeId === 0 || Number(out.id) === normalizedTypeId;

                    if (!typeMatches) {
                        return {
                            ...out,
                            ous: []
                        };
                    }

                    const filteredOus = out.ous.filter(ou => {
                        if (!normalizedSearch) {
                            return true;
                        }

                        return String(ou.name).toLowerCase().includes(normalizedSearch);
                    });

                    return {
                        ...out,
                        ous: filteredOus
                    };
                })
                .filter(out => out.ous.length > 0);

            this.populateColumnAvailableOUs(filteredAvailableOuts);
        },

        isOuSelected(ouId) {
            return this.ou_available_ids.map(id => Number(id)).includes(Number(ouId));
        },

        toggleOuAvailability(ouId, checked) {
            const normalizedOuId = Number(ouId);
            const currentIds = this.ou_available_ids.map(id => Number(id));
            const alreadySelected = currentIds.includes(normalizedOuId);

            if (checked && !alreadySelected) {
                this.ou_available_ids = [...currentIds, normalizedOuId];
            }

            if (!checked && alreadySelected) {
                this.ou_available_ids = currentIds.filter(id => id !== normalizedOuId);
            }

            this.getFilteredOrganizationalUnits(this.out_selected, this.filter_bar);
        },

        populateColumnsWithOUs() {
            this.getFilteredOrganizationalUnits(this.out_selected, this.filter_bar);
        },

        populateColumnAvailableOUs(filteredAvailableOuts = this.ou_all) {

            //Example of populating column 2 with the available OUs for the area of interest question, it can be replicated for other questions if needed --- IGNORE ---

            const availableIds = this.ou_available_ids.map(id => Number(id));

            this.out_with_ou_list = filteredAvailableOuts
                .map(out => ({
                    ...out,
                    ous: out.ous.filter(ou => !availableIds.includes(Number(ou.id)))
                }))
                .filter(out => out.ous.length > 0);

            this.out_with_ou_selected = this.ou_all
                .map(out => ({
                    ...out,
                    ous: out.ous.filter(ou => availableIds.includes(Number(ou.id)))
                }))
                .filter(out => out.ous.length > 0);
        },

        getAllOuGroupedByType() {

            axios.get('/api/questions-survey/areas-of-interest/get-all-ou-grouped-by-type/', {

            }).then((response) => {
                this.ou_all = response.data;
            });
        },

        toggle(action, item_id, editing, attributes) {
            this.active = true;
            this.action = action;
            this.editing = editing;
            this.lang = attributes.lang;
            this.title = this.__("forms.EvaluationChart.questions.questions_setting.question43.title")
            let dataRoute = decodeURI(attributes.dataRoute);
            if (dataRoute !== undefined) {
                if (dataRoute.indexOf("[id]") > 0) {
                    dataRoute = dataRoute.replace("[id]", item_id);

                }
                axios.get(dataRoute)
                    .then((response) => {

                        this.name = response.data.base.name;
                        this.description = response.data.base.description;
                        this.sorting = response.data.base.sorting;
                        this.can_write = app.__vue__.questionPermission(this.can_write, response.data.base.enable);
                        //question_specific
                        this.ou_available_ids = response.data.settings.ou_available;
                        this.ou_types_for_filters = response.data.settings.ou_types_for_filters;
                        this.out_selected = 0;
                        this.filter_bar = '';
                        //Populate column 2 and 3 with the OUs based on the response, this is just an example for the area of interest question, 
                        this.populateColumnsWithOUs();
                    });
            }
        }

    }

}
</script>

<style scoped>
.ou-type-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-height: 420px;
    overflow-y: auto;
    padding-right: 4px;
}

.ou-type-card {
    background: #f4f7fb;
    border: 1px solid #dce4ef;
    border-radius: 8px;
    padding: 10px 12px;
}

.ou-type-card--selected {
    background: #eef8f2;
    border-color: #cfe7d7;
}

.ou-filter-card {
    background: #f4f7fb;
    border: 1px solid #dce4ef;
    border-radius: 8px;
    padding: 12px;
}

.ou-filter-card__label {
    font-size: 13px;
    font-weight: 600;
    color: #2f3e4f;
    margin-bottom: 8px;
}

.ou-type-card__title {
    font-size: 13px;
    font-weight: 600;
    color: #2f3e4f;
    margin-bottom: 8px;
}

.ou-checkbox-row {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    font-size: 13px;
    color: #4b5b6b;
}

.ou-checkbox-row:last-child {
    margin-bottom: 0;
}
</style>
